module.exports = __webpack_public_path__ + "img/HQ-PS24-V1-T.47af9810.jpg";